import React, { useEffect, useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
// import { getOtpMode } from '../../store/users';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { emailOtpSelector, getOtpMode, otpmessageSelector, startGettingEmailOtpList, startGettingPhoneOtpList, startSecurityQuestion, userPhoneResponseSelector } from '../../../../Store/UsersAccount/userAccount.slice.selector';

const ChangePasswordBox = ({ onNext, onBack, buttonName, setEmailValue }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const otpModeSelected = useSelector(getOtpMode)
  const phoneMode = useSelector(userPhoneResponseSelector)
  const otpemailMessage = useSelector(emailOtpSelector)
  const phonemailMessage = useSelector(userPhoneResponseSelector)
  const dispatch = useDispatch()

  const handleChange = (e) => {
    // setPassword(e.target.value);
    const { value } = e.target;
    let isValid = true;

    if (otpModeSelected === 'Email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      isValid = emailRegex.test(value);
    } else if (otpModeSelected === 'Mobile') {
      const mobileRegex = /^[0-9]{10}$/;
      isValid = mobileRegex.test(value);
    }

    setPassword(value);
    setError(!isValid);
  };

  const handleSubmit = () => {
    if (otpModeSelected === "Email") {
      dispatch(startGettingEmailOtpList(password))
    } else if (otpModeSelected === "Mobile") {
      dispatch(startGettingPhoneOtpList(password))
    } else {
      dispatch(startSecurityQuestion(password))
      dispatch(startGettingEmailOtpList(password))
      setEmailValue(password)
    }
    // if (password) {
    //   onNext();
    // }
  };

  useEffect(() => {
    if (otpemailMessage === "email otp send") {
      onNext();
    }
  }, [otpemailMessage])

  useEffect(() => {
    if (phonemailMessage === "phone otp send") {
      onNext();
    }
  }, [phonemailMessage])

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
        <Button
          variant="outlined"
          color="secondary"
          sx={{
            border: 'none',
            '&:hover': {
              border: 'none',
            }
          }}
          onClick={onBack}
        >
          <ArrowBackIcon /> Back
        </Button>
      </Box>
      <Typography variant="h5" sx={{ fontWeight: '600', paddingBottom: "5px", marginTop: "5px" }}>{buttonName}?</Typography>
      <Typography variant="h6" sx={{ marginTop: "5px", paddingBottom: "9px", marginBottom: "5px" }}>Please Enter {otpModeSelected} {otpModeSelected === "Security" ? "Email" : ""}</Typography>
      <TextField
        value={password}
        onChange={handleChange}
        label={`Please Enter ${otpModeSelected} ${otpModeSelected === "Security" ? "Email" : ""}`}
        variant="outlined"
        fullWidth
        error={error}
        helperText={error ? `Invalid ${otpModeSelected} Format` : ''}
        sx={{ mt: 3, paddingBottom: "5px", marginTop: "5px" }}
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{
          mt: 3,
          backgroundColor: "#f5365c",
          borderColor: "#f5365c",
          '&:hover': {
            backgroundColor: '#f5365c',
            color: 'white',
            border: 'none',
          }
        }}
        onClick={handleSubmit}>
        Submit
      </Button>


    </Box>
  );
};

export default ChangePasswordBox;
